import React from 'react'
import { Link } from 'react-router-dom'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import CheckBoxUI from '../../../widgets/input/CheckBoxUI'
import SelectUI from '../../../widgets/input/SelectUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import TriangulationUI from '../../../components/superUser/clientTxn/TriangulationUI'
import Triangulation6MonthsUI from '../../../components/superUser/clientTxn/Triangulation6MonthsUI'
import NetCashFlowUI from '../../../components/superUser/clientTxn/NetCashFlowUI'
import TriangulationNavUI from './TriangulationNavUI.js'
import './TriangulationPage.css'

const TriangulationPageUI = ({ context, account, accountYearList, financialsFromMCA, onRefreshClick,
  bankChecked, gstChecked, pnlChecked,
  selectedYear, selectedSection, onShowMonthly,
  accountMonthGstList, accountMonthBankList, nMonthGstTotal, nMonthBankTotal, lastNMonths, lastNMonthsList, onLastNMonthsChange, showGstData, onShowGstDataClick,
  netCashFlowList,
  submitted, onSubmit, onClearClick, onShowDetails, showDetails, showNetProfit, onShowNetProfit,
  startYear, endYear, yearList, onStartYearChange, onEndYearChange, startMonth, endMonth, monthList, onStartMonthChange, onEndMonthChange
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_tri' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!accountYearList}
    account={account} page='triangulations'
  >
    {
      !accountYearList &&
      <SpinnerComponentUI />
    }
    {
      accountYearList &&
      <div className='body'>
        <div className='su_tri'>
          <LRTableActionsUI location='top'
            left={
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
                <span className='g_m_left_100 g_large'><b>Triangulation</b></span>
              </span>
            }
            right={<span />}
          />
          <TriangulationNavUI account={account} page='data' />
          <span className='g_flex_h g_flex_right g_m_bottom_100'>
            <SelectUI selectedKey={startYear} optionList={yearList} onChange={onStartYearChange} placeholder='Year' />
            <SelectUI selectedKey={startMonth} optionList={monthList} onChange={onStartMonthChange} placeholder='Month' />
            <span className='g_m_left_50'>-</span>
            <span className='g_m_left_50' />
            <SelectUI className='g_m_left_50' selectedKey={endYear} optionList={yearList} onChange={onEndYearChange} placeholder='Year' />
            <SelectUI selectedKey={endMonth} optionList={monthList} onChange={onEndMonthChange} placeholder='Month' />
            <Link className='g_m_left_100' to='#' onClick={onSubmit}>Submit</Link>
            <SpinnerUI className='g_m_left_50' show={submitted} />
            <Link className='g_m_left_100' to='#' onClick={onClearClick}>Clear</Link>
            <Link className='g_m_left_100' to='#' onClick={onShowDetails}>Details</Link>
          </span>
        </div>
        {/*
        <SelectorUI
          bankChecked={bankChecked} gstChecked={gstChecked} pnlChecked={pnlChecked}
          onBankClick={onBankClick} onGSTClick={onGSTClick} onPnLClick={onPnLClick}
        />
        */}

        {
          !accountYearList.length &&
          <div className='g_m_top_200 g_text_center'>No triangulations data</div>
        }

        {
          accountYearList.length !== 0 &&
          <TriangulationUI
            context={context}
            account={account}
            accountYearList={accountYearList} financialsFromMCA={financialsFromMCA}
            bankChecked={bankChecked} gstChecked={gstChecked} pnlChecked={pnlChecked} showDetails={showDetails}
            selectedYear={selectedYear} selectedSection={selectedSection} onShowMonthly={onShowMonthly}
            showNetProfit={showNetProfit} onShowNetProfit={onShowNetProfit}
          />
        }
        {
          accountMonthGstList && accountMonthGstList.length > 0 &&
          accountMonthBankList && accountMonthBankList.length > 0 &&
          <Triangulation6MonthsUI
            context={context}
            account={account}
            accountMonthGstList={accountMonthGstList}
            accountMonthBankList={accountMonthBankList}
            nMonthGstTotal={nMonthGstTotal}
            nMonthBankTotal={nMonthBankTotal}
            lastNMonths={lastNMonths} lastNMonthsList={lastNMonthsList}
            onLastNMonthsChange={onLastNMonthsChange}
            showDetails={showDetails}
            showGstData={showGstData}
            onShowGstDataClick={onShowGstDataClick}
          />
        }
        {
          netCashFlowList &&
          <NetCashFlowUI
            context={context}
            account={account}
            netCashFlowList={netCashFlowList}
          />
        }
        {/*
          accountYearList.length !== 0 &&
          <TriangulationListUI
            context={context}
            account={account}
            accountYearList={accountYearList}
            bankChecked={bankChecked} gstChecked={gstChecked} pnlChecked={pnlChecked}
            selectedYear={selectedYear} onShowMonthly={onShowMonthly}
          />
        */}
      </div>
    }
  </SuperUserAccountPageUI>

const SelectorUI = ({ bankChecked, gstChecked, pnlChecked, onBankClick, onGSTClick, onPnLClick,
}) =>
  <div className='g_flex_h'>
    <CheckBoxUI label='Bank' checked={bankChecked} onChange={onBankClick} />
    <CheckBoxUI label='GST' checked={gstChecked} onChange={onGSTClick} className='g_m_left_100' />
    <CheckBoxUI label='PnL' checked={pnlChecked} onChange={onPnLClick} className='g_m_left_100 g_m_right_100' />
  </div>

const TriangulationListUI = ({ context, account, accountYearList, bankChecked, gstChecked, pnlChecked, selectedYear, onShowMonthly }) =>
  <table className='tabl'>
    <thead className='g_sticky'>
      <tr>
        <th />
        <th>Month</th>
        {
          bankChecked &&
          <>
            <th>Bank Collections</th>
            <th>Bank Payments</th>
            <th>Bank Profit/Loss</th>
          </>
        }
        {
          gstChecked &&
          <>
            <th>GST Collections</th>
            <th>GST Payments</th>
            <th>GST Profit/Loss</th>
          </>
        }
        {
          pnlChecked &&
          <>
            <th>PnL Collections</th>
            <th>PnL Payments</th>
            <th>PnL Profit/Loss</th>
          </>
        }
        {
          bankChecked && gstChecked &&
          <>
            <th>BankGST<br />Collections<br />Ratio</th>
            <th>BankGST<br />Payments<br />Ratio</th>
          </>
        }
        {
          bankChecked && pnlChecked &&
          <>
            <th>BankPnL<br />Collections<br />Ratio</th>
            <th>BankPnL<br />Payments<br />Ratio</th>
          </>
        }
        {
          gstChecked && pnlChecked &&
          <>
            <th>GSTPnL<br />Collections<br />Ratio</th>
            <th>GSTPnL<br />Payments<br />Ratio</th>
          </>
        }
      </tr>
    </thead>
    <tbody>
      {
        accountYearList.map((accountYear, i) =>
          <TriangulationYearUI key={i} context={context} account={account} accountYear={accountYear}
            bankChecked={bankChecked} gstChecked={gstChecked} pnlChecked={pnlChecked}
            selectedYear={selectedYear} onShowMonthly={onShowMonthly}
          />
        )
      }
    </tbody>
  </table>

const TriangulationYearUI = ({ context, account, accountYear,
  bankChecked, gstChecked, pnlChecked, selectedYear, onShowMonthly
}) =>
  <>
    <tr>
      <th>
        <Link to='#' onClick={onShowMonthly} data-year={accountYear.financialYear}>
          {
            selectedYear === accountYear.financialYear &&
            <span className="icon icon-angle-down g_xxlarge"></span>
          }
          {
            selectedYear !== accountYear.financialYear &&
            <span className="icon icon-angle-right g_xxlarge"></span>
          }
        </Link>
      </th>
      <th className='g_text_right g_no_wrap_2'>{accountYear.financialYear}</th>
      {
        bankChecked &&
        <>
          <th className='g_text_right'>{accountYear.totalBankCollectionF4}</th>
          <th className='g_text_right'>{accountYear.totalBankPaymentF4}</th>
          <th className='g_text_right'>{accountYear.totalBankProfitLoss < 0 ? `(${accountYear.totalBankProfitLossF4})` : accountYear.totalBankProfitLossF4}</th>
        </>
      }
      {
        gstChecked &&
        <>
          <th className='g_text_right'>{accountYear.totalGstCollectionF4}</th>
          <th className='g_text_right'>{accountYear.totalGstPaymentF4}</th>
          <th className='g_text_right'>{accountYear.totalGstProfitLoss < 0 ? `(${accountYear.totalGstProfitLossF4})` : accountYear.totalGstProfitLossF4}</th>
        </>
      }
      {
        pnlChecked &&
        <>
          <th className='g_text_right'>{accountYear.totalPnLCollectionF4}</th>
          <th className='g_text_right'>{accountYear.totalPnLPaymentF4}</th>
          <th className='g_text_right'>{accountYear.totalPnLProfitLoss < 0 ? `(${accountYear.totalPnLProfitLossF4})` : accountYear.totalPnLProfitLossF4}</th>
        </>
      }
      {
        bankChecked && gstChecked &&
        <>
          <RatioTHUI ratio={accountYear.collectionRatio} />
          <RatioTHUI ratio={accountYear.paymentRatio} />
        </>
      }
      {
        bankChecked && pnlChecked &&
        <>
          <RatioTHUI ratio={accountYear.bankFinancialCollection} />
          <RatioTHUI ratio={accountYear.bankFinancialPayment} />
        </>
      }
      {
        gstChecked && pnlChecked &&
        <>
          <RatioTHUI ratio={accountYear.gstFinancialCollection} />
          <RatioTHUI ratio={accountYear.gstFinancialPayment} />
        </>
      }
    </tr>
    {
      selectedYear === accountYear.financialYear && accountYear.accountMonthList.map((monthlyData, i) =>
        <TriangulationMonthUI key={i} context={context} account={account} monthlyData={monthlyData}
          bankChecked={bankChecked} gstChecked={gstChecked} pnlChecked={pnlChecked}
        />
      )
    }
  </>

const TriangulationMonthUI = ({ context, account, monthlyData,
  bankChecked, gstChecked, pnlChecked
}) =>
  <tr>
    <td></td>
    <td className='g_text_right g_no_wrap_2'>{monthlyData.yearMonth}</td>
    {
      bankChecked &&
      <>
        <td className='g_text_right'>
          <Link to={`/su/accounts/${account.accountId}/clientTxnCashTransactions/trade_credits/${monthlyData.year}/${monthlyData.month}`}>
            {monthlyData.bankCollectionF4}
          </Link>
        </td>
        <td className='g_text_right'>
          <Link to={`/su/accounts/${account.accountId}/clientTxnCashTransactions/trade_debits/${monthlyData.year}/${monthlyData.month}`}>
            {monthlyData.bankPaymentF4}
          </Link>
        </td>
        <td className='g_text_right'>{monthlyData.bankProfitLoss < 0 ? `(${monthlyData.bankProfitLossF4})` : monthlyData.bankProfitLossF4}</td>
      </>
    }
    {
      gstChecked &&
      <>
        <td className='g_text_right'>{monthlyData.gstCollectionF4}</td>
        <td className='g_text_right'>{monthlyData.gstPaymentF4}</td>
        <td className='g_text_right'>{monthlyData.gstProfitLoss < 0 ? `(${monthlyData.gstProfitLossF4})` : monthlyData.gstProfitLossF4}</td>
      </>
    }
    {
      pnlChecked &&
      <>
        <td />
        <td />
        <td />
      </>
    }
    {
      bankChecked && gstChecked &&
      <>
        <RatioTDUI ratio={monthlyData.collectionRatio} />
        <RatioTDUI ratio={monthlyData.paymentRatio} />
      </>
    }
    {
      bankChecked && pnlChecked &&
      <>
        <RatioTDUI ratio={monthlyData.bankFinancialCollection} />
        <RatioTDUI ratio={monthlyData.bankFinancialPayment} />
      </>
    }
    {
      gstChecked && pnlChecked &&
      <>
        <RatioTDUI ratio={monthlyData.gstFinancialCollection} />
        <RatioTDUI ratio={monthlyData.gstFinancialPayment} />
      </>
    }
  </tr>

const RatioTHUI = ({ ratio }) =>
  <th className={`g_text_right ${ratio ?
    ((ratio < 0.8 || ratio > 1.25) ? 'g_error' : 'g_success') :
    ''}`}>
    {
      ratio > 999 &&
      <span className='g_xxlarge'>∞</span>
    }
    {
      ratio <= 999 &&
      <span>{ratio}</span>
    }
  </th>

const RatioTDUI = ({ ratio }) =>
  <td className={`g_text_right ${ratio ?
    ((ratio < 0.8 || ratio > 1.25) ? 'g_error' : 'g_success') :
    ''}`}>
    {
      ratio > 999 &&
      <span className='g_xxlarge'>∞</span>
    }
    {
      ratio <= 999 &&
      <span>{ratio}</span>
    }
  </td>

export default TriangulationPageUI
